import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PatrimonioDashboard } from '../../modules/patrimonio/ui/PatrimonioDashboard';
import { ModernIngresosDashboard } from '../../modules/ingresos/ui/ModernIngresosDashboard';

import { ModernInversionesDashboard } from '../../modules/inversiones/ui/ModernInversionesDashboard';
import { ModernReportesDashboard } from '../../modules/reportes/ui/ModernReportesDashboard';
import { ModernEgresosDashboard } from '../../modules/egresos/ui/ModernEgresosDashboard';
import { SimpleMainDashboard } from './components/SimpleMainDashboard';
import DashboardHeader from './components/DashboardHeader';
import ResumenesSection from './components/ResumenesSection';
import { UserProfile } from '../../components/user/UserProfile';
import { UserSettings } from '../../components/user/UserSettings';
import { UserSecurity } from '../../components/user/UserSecurity';
import { OnboardingWizard, useOnboarding } from '../../modules/onboarding';

export default function Dashboard() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Hook de onboarding
  const { shouldShowOnboarding } = useOnboarding();

  // Detectar la sección activa basada en la URL
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/ingresos')) {
      setActiveSection('ingresos');
    } else if (path.includes('/egresos')) {
      setActiveSection('egresos');
    } else if (path.includes('/inversiones')) {
      setActiveSection('inversiones');
    } else if (path.includes('/patrimonio')) {
      setActiveSection('patrimonio');
    } else {
      setActiveSection('dashboard');
    }
  }, [location.pathname]);

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <SimpleMainDashboard />;
      case 'patrimonio':
        return <PatrimonioDashboard />;
      case 'ingresos':
        return <ModernIngresosDashboard />;
      case 'egresos':
        return <ModernEgresosDashboard />;
      case 'inversiones':
        return <ModernInversionesDashboard />;
      case 'resumenes':
        return <ResumenesSection />;
      case 'reportes':
        return <ModernReportesDashboard />;
      case 'profile':
        return <UserProfile />;
      case 'settings':
        return <UserSettings />;
      case 'security':
        return <UserSecurity />;
      default:
        return <SimpleMainDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DashboardHeader 
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />
      
      <main className="pt-16">
        {renderActiveSection()}
      </main>

      {/* Wizard de onboarding */}
      {shouldShowOnboarding() && (
        <OnboardingWizard 
          onComplete={() => {
            // Opcional: hacer algo cuando se complete
            console.log('Onboarding completado');
          }}
          onSkip={() => {
            // Opcional: hacer algo cuando se salte
            console.log('Onboarding saltado');
          }}
        />
      )}
    </div>
  );
}